<template>
    <v-container class="pa-5" fluid>
        <GenerateLabelsDialog
            :is-open="generateDialogLabelsOpen"
            :validate-file="currentClient === availableClients[0]"
            @on-loaded="xlsDataLoaded"
            @on-close="closeGenerateDialogLabels"
        />
        <ImportDataLabelsDialog
            :is-open="importDataLabelsDialog"
            @action-loading="actionLoading.importDataLabels"
            @on-close="closeImportDataLabelsDialog"
            @on-import="importDataLabels"
        />
        <AddEditLabelsWithEANDialog
            v-if="currentClient === availableClients[0]"
            :item="editedItem"
            :is-open="addEditLabelsDialogOpen"
            @on-save="saveLabelsChanges"
            @on-close="closeAddEditLabelsDialog"
        />
        <AddEditLabelsWithCityDialog
            v-else
            :item="editedItem"
            :is-open="addEditLabelsDialogOpen"
            @on-save="saveLabelsChanges"
            @on-close="closeAddEditLabelsDialog"
        />
        <ConfirmDialog
            removal
            :is-open="deleteLabelsDialogOpen"
            @on-confirm="confirmDeleteLabels"
            @on-abort="cancelGenerateLabelsDialog"
        >
            <template #title>
                Usuwanie etykiety
            </template>
            <template #content>
                Czy na pewno chcesz usunąć etykietę?
            </template>
            <template #confirmButton>
                Usuń
            </template>
        </ConfirmDialog>

        <ConfirmDialog
            removal
            :is-open="updateDataDialogOpen"
            @on-confirm="confirmUpdateDataDialog"
            @on-abort="cancelUpdateDataDialog"
        >
            <template #title>
                Czy jesteś pewien?
            </template>
            <template #content>
                Wszystkie dane zostaną utracone?
            </template>
            <template #confirmButton>
                Kontynuuj
            </template>
        </ConfirmDialog>

        <WorkspaceSettingsDialog
            :is-open="workspaceSettingsDialog"
            :workspace-id-data="workspaceId"
            :workspaces="workspaces"
            @on-save="saveWorkspaceSettings"
            @on-abort="closeWorkspaceSettingsDialog"
        />
        <v-row dense>
            <v-col cols="auto">
                <page-title>Generator etykiet standardowych</page-title>
            </v-col>
        </v-row>
        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót
                </v-btn>
            </v-col>
        </v-row>
        <v-row justify="space-between">
            <v-col cols="12" md="2" sm="4">
                <v-select
                    v-model="clientModel"
                    label="Client"
                    :items="availableClients"
                    item-value="id"
                    item-text="name"
                    no-data-text="Nie znaleziono grupy"
                    solo
                    hide-details
                    @change="beforeClientChanged"
                />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="4" xl="3">
                <v-card>
                    <v-toolbar flat dense color="grey lighten-4">
                        <v-container class="pa-0">
                            <v-row justify="space-between" dense align="center">
                                <v-col>
                                    <v-toolbar-title class="text-subtitle-1">
                                        Stanowisko
                                    </v-toolbar-title>
                                </v-col>
                                <v-col cols="auto">
                                    <v-tooltip :open-delay="tooltipDelay" top>
                                        <template #activator="{on}">
                                            <v-btn
                                                v-if="canChangeWorkspace"
                                                fab
                                                x-small
                                                color="secondary"
                                                elevation="1"
                                                :loading="actionLoading.workspaces"
                                                v-on="on"
                                                @click="showWorkspaceSettingsDialog(false)"
                                            >
                                                <v-icon>
                                                    mdi-printer-3d
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Zmiana stanowiska</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-toolbar>

                    <v-divider />

                    <v-card-text class="py-8 text-center">
                        <div class="text-h3 font-weight-bold black--text">
                            {{ currentWorkspace ? currentWorkspace.name : '-' }}
                        </div>
                    </v-card-text>
                    <v-col cols="12">
                        <v-select
                            v-model="printerId"
                            :items="printers"
                            item-value="id"
                            item-text="name"
                            label="Drukarka"
                            hide-details
                            no-data-text="Nie znaleziono drukarki"
                            outlined
                            dense
                        />
                    </v-col>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" lg="6">
                <v-btn
                    color="secondary"
                    medium
                    class="mr-4"
                    data-sentry-label="Importuj dane"
                    @click="beforeShowGenerateLabelsDialog()"
                >
                    <v-icon left>
                        mdi-file-upload-outline
                    </v-icon>
                    Importuj dane
                </v-btn>
                <v-btn
                    v-if="currentClient === availableClients[0]"
                    color="secondary"
                    medium
                    class="mr-4"
                    data-sentry-label="Importuj dane z kampanii"
                    @click="showImportLabelsDatadialog()"
                >
                    <v-icon left>
                        mdi-file-upload-outline
                    </v-icon>
                    Importuj z kampanii
                </v-btn>
                <v-btn
                    color="primary"
                    medium
                    data-sentry-label="Dodaj etykietę"
                    :disabled="!items.length"
                    @click="showAddEditLabelsDialog({})"
                >
                    <v-icon left>
                        mdi-plus
                    </v-icon>
                    Dodaj
                </v-btn>
            </v-col>
            <v-col cols="12" lg="6" class="d-flex justify-end">
                <v-btn
                    color="primary"
                    medium
                    data-sentry-label="Wydrukuj wszystkie etykiety"
                    :disabled="!items.length || !haveToPrint() || !printerId"
                    @click="printLabels(items)"
                >
                    <v-icon left>
                        mdi-printer
                    </v-icon>
                    Wydrukuj wszystkie etykiety
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="errorFormat">
            <v-col cols="12">
                <v-alert
                    border-color="orange-lighten-3 accent-4"
                    variant="tonal"
                    type="error"
                    elevation="2"
                >
                    Wygląda na to, że format pliku nie jest zgodny z szablonem wybranego klienta.
                </v-alert>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-data-table
                    :items="items"
                    :headers="headers"
                >
                    <template #item.copies="{item}">
                        <v-edit-dialog
                            :return-value.sync="item.copies"
                            large
                            cancel-text="Anuluj"
                            save-text="Zapisz"
                        >
                            {{ item.copies || 0 }}
                            <v-icon color="blue" small>
                                mdi-pencil
                            </v-icon>
                            <template #input>
                                <v-text-field
                                    v-model="item.copies"
                                    v-mask="'####'"
                                    :rules="[validIntegerRules]"
                                    single-line
                                    autofocus
                                    clearable
                                    @focus="clearIfNil(item)"
                                />
                            </template>
                        </v-edit-dialog>
                    </template>

                    <template #item.actions="{item}">
                        <div class="d-inline-flex">
                            <v-tooltip :open-delay="tooltipDelay" top>
                                <template #activator="{on}">
                                    <v-btn
                                        icon
                                        data-sentry-label="Edytuj"
                                        v-on="on"
                                        @click="showAddEditLabelsDialog(item)"
                                    >
                                        <v-icon color="teal">
                                            mdi-pencil
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Edytuj</span>
                            </v-tooltip>
                            <v-tooltip :open-delay="tooltipDelay" top>
                                <template #activator="{on}">
                                    <v-btn
                                        icon
                                        data-sentry-label="Wydrukuj etykietę"
                                        :disabled="(item.copies == 0 && currentClient === availableClients[0]) || !printerId"
                                        v-on="on"
                                        @click="printLabels([item])"
                                    >
                                        <v-icon :color="actualPrintIconColor(item)">
                                            mdi-printer
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Wydrukuj etykietę</span>
                            </v-tooltip>
                            <v-tooltip top :open-delay="tooltipDelay">
                                <template #activator="{on}">
                                    <v-btn
                                        icon
                                        data-sentry-label="Usuń"
                                        v-on="on"
                                        @click="deleteLabels(item)"
                                    >
                                        <v-icon color="pink">
                                            mdi-delete
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Usuń</span>
                            </v-tooltip>
                        </div>
                    </template>

                    <template slot="no-data">
                        <p class="text-center mt-4">
                            Brak danych
                            <v-btn
                                color="secondary"
                                class="mr-4"
                                small
                                text
                                data-sentry-label="Importuj"
                                @click="showGenerateLabelsDialog()"
                            >
                                <v-icon left>
                                    mdi-file-upload-outline
                                </v-icon>
                                Importuj
                            </v-btn>
                        </p>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import store from '@/./store'
import router from '@/router'
import _ from 'lodash'
import PageTitle from '@/components/common/PageTitle'
import ConfirmDialog from '@/components/common/ConfirmDialog'
import GenerateLabelsDialog from './GenerateLabelsDialog'
import AddEditLabelsWithCityDialog from './AddEditLabelsWithCityDialog'
import AddEditLabelsWithEANDialog from './AddEditLabelsWithEANDialog'
import ImportDataLabelsDialog from './ImportDataLabelsDialog'
import WorkspaceSettingsDialog from './WorkspaceSettingsDialog'
import tooltipDelay from '@/mixins/tooltip'
import { isInteger } from '@/utils/customValidators'
import { hasUserPermission } from '@/utils/permissionsHandler'
import { errorHandler, addSentryBreadcrumb } from '@/utils/errorHandler'

const availableClients = ['Biedronka', 'Lidl']

export default {
    name: 'StandardLabels',
    components: {
        PageTitle,
        GenerateLabelsDialog,
        AddEditLabelsWithCityDialog,
        AddEditLabelsWithEANDialog,
        ConfirmDialog,
        WorkspaceSettingsDialog,
        ImportDataLabelsDialog
    },
    mixins: [
        tooltipDelay
    ],
    beforeRouteEnter(to, from, next) {
        store.dispatch('configurations/getProductionSites', {query:'?type_id=6'})
            .then(() => {
                next(vm => {
                    const workspace = JSON.parse(localStorage.getItem('standardLabelsWorkspace'))

                    if (!workspace) {
                        vm.showWorkspaceSettingsDialog()
                    } else {
                        vm.workspaceId = workspace.workspaceId
                        vm.setStandardLabelsSettings(vm.workspaceId)
                    }
                })
            })
            .catch(error => {
                next(error)
                errorHandler(error)
            })
    },
    data() {
        return {
            availableClients,
            generateDialogLabelsOpen: false,
            importDataLabelsDialog: false,
            addEditLabelsDialogOpen: false,
            deleteLabelsDialogOpen: false,
            updateDataDialogOpen : false,
            currentAction: null,
            labelLoading: false,
            updated: false,
            xlsData: null,
            fileName: null,
            items: [],
            editedItem: null,
            editedIndex: null,
            clientModel: availableClients[0],
            currentClient: availableClients[0],
            settings : {
                workspace: null
            },
            actionLoading: {
                workspaces: false,
                importDataLabels: false
            },
            workspaceId: null,
            workspaceSettingsDialog: false,
            printerId: null,
            validIntegerRules:
                v => (isInteger(v) && _.inRange(v, 0, Infinity)) || 'Nieprawidłowy format',
            headers: [],
            headersInitial: [
                {
                    text: 'Akcje',
                    value: 'actions',
                    align: 'right',
                    sortable: false,
                    width: 100,
                    showOnReadOnly: false
                }
            ],
            ['headers' + availableClients[0]]: [
                {
                    text: 'Format sklepu',
                    value: 'shopFormat',
                    align: 'left',
                    sortable: false
                },
                {
                    text: 'Indeks',
                    value: 'shopIndex',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'EAN',
                    value: 'ean',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'Ilość',
                    value: 'copies',
                    align: 'center',
                    sortable: false
                },
            ],
            ['headers' + availableClients[1]]: [
                {
                    text: 'Numer',
                    value: 'number',
                    align: 'left',
                    sortable: false
                },
                {
                    text: 'Nazwa',
                    value: 'name',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'Sklep',
                    value: 'shop',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'Miasto',
                    value: 'city',
                    align: 'center',
                    sortable: false
                },
            ],
        }
    },
    computed: {
        workspaces() {
            return this.$store.state.configurations.productionSites.productionSites
        },
        currentWorkspace() {
            return this.standardLabelsSettings?.workspace
        },
        printers() {
            if (this.currentWorkspace) {
                return this.currentWorkspace.printers
            }

            return []
        },
        standardLabelsSettings() {
            return this.$store.state.shipments.labelsGenerator.labelsGenerator.standardLabelsSettings
        },
        canChangeWorkspace() {
            return hasUserPermission('production_sites_admin_update')
        },
        errorFormat() {
            if (!this.items.length || this.updated) return false
            let results = this.items.filter(item => {
                if (
                    (item.number && typeof item.number !== 'number') ||
                    (item.name && typeof item.name !== 'string') ||
                    (item.shopIndex && typeof item.shopIndex !== 'number') ||
                    (item.shopFormat && typeof item.shopFormat !== 'string')
                ) {
                    return true
                }

                return false
            })

            return results.length !== 0
        }
    },
    methods: {
        setDefaultPrinter(workspace) {
            if (workspace) {
                if (workspace.printerId) {
                    return this.printerId = workspace.printerId
                } else if (workspace.printers.length > 0) {
                    return this.printerId = workspace.printers[0].id
                }
            }

            return this.printerId = null
        },
        setStandardLabelsSettings(workspaceId) {
            this.getWorkspace(workspaceId).then(response => {
                this.workspaceId = response.data.id
                localStorage.setItem('standardLabelsWorkspace', JSON.stringify({
                    'workspaceId': workspaceId,
                }))
                this.settings.workspace = response.data
                store.dispatch('shipments/labelsGenerator/setStandardLabelsSettings', this.settings)
                this.setDefaultPrinter(this.settings.workspace)
            })
        },
        async getWorkspace(workspaceId) {
            return await this.$store.dispatch('configurations/getProductionSite', workspaceId)
                .catch(error => {
                    errorHandler(error)
                })
        },
        showWorkspaceSettingsDialog() {
            this.actionLoading.workspaces = true
            addSentryBreadcrumb('ui.action', 'Ustawienia stanowiska')

            this.$store.dispatch('configurations/getProductionSites', {query:'?type_id=6'})
                .then(() => {
                    this.workspaceSettingsDialog = true
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.workspaces = false
                })
        },
        closeWorkspaceSettingsDialog() {
            this.workspaceSettingsDialog = false
        },
        saveWorkspaceSettings(value) {
            this.setStandardLabelsSettings(value)
            this.closeWorkspaceSettingsDialog()
        },
        confirmUpdateDataDialog() {
            this.currentAction.action(this.currentAction.param)
            this.updateDataDialogOpen = false
        },
        cancelUpdateDataDialog() {
            if (this.currentAction.prev) {
                this.clientModel = this.currentAction.prev
            }
            this.updateDataDialogOpen = false
        },
        beforeClientChanged(client) {
            this.currentAction = {
                action: this.changeClient,
                param: client,
                prev: this.currentClient
            }
            if (this.items.length > 0) {
                this.updateDataDialogOpen = true
            } else {
                this.changeClient(client)
            }
        },
        changeClient(client) {
            this.currentClient = client
            this.items = []
            this.headers = []
            this.currentAction = null
        },
        haveToPrint() {
            if (this.currentClient === availableClients[1]) {
                return true
            }

            return this.items.reduce((acc, item) => acc + +item.copies, 0)
        },
        beforeShowGenerateLabelsDialog() {
            this.currentAction = {
                action: this.showGenerateLabelsDialog,
            }
            if (this.items.length > 0) {
                this.updateDataDialogOpen = true
            } else {
                this.showGenerateLabelsDialog()
            }
        },
        showImportLabelsDatadialog() {
            this.importDataLabelsDialog = true
        },
        closeImportDataLabelsDialog() {
            this.importDataLabelsDialog = false
        },
        showGenerateLabelsDialog() {
            this.generateDialogLabelsOpen = true
            this.currentAction = null
        },
        showAddEditLabelsDialog(item) {
            this.editedIndex = this.items.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.addEditLabelsDialogOpen = true
            this.updated = true
        },
        closeGenerateDialogLabels() {
            this.generateDialogLabelsOpen = false
        },
        closeAddEditLabelsDialog() {
            this.addEditLabelsDialogOpen = false
        },
        saveLabelsChanges(newItem) {
            if (this.editedIndex > -1) {
                Object.assign(this.items[this.editedIndex], newItem)
            } else {
                newItem.id = this.items.length
                this.items.unshift(newItem)
            }
        },
        deleteLabels(item) {
            this.editedIndex = this.items.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.deleteLabelsDialogOpen = true
        },
        cancelGenerateLabelsDialog() {
            this.editedIndex = -1
            this.editedItem = null
            this.deleteLabelsDialogOpen = false
        },
        confirmDeleteLabels() {
            this.items.splice(this.editedIndex, 1)
            this.deleteLabelsDialogOpen = false
        },
        printLabels(items) {
            if (this.currentClient === this.availableClients[0]) {
                this.printEANLabels(items)
            } else {
                this.printCustomLabels(items)
            }
        },
        printEANLabels(items) {
            const EANLabels = items
                .filter(item => item.copies > 0)
                .map(item => ({
                    EAN: item.ean,
                    shopFormat: item.shopFormat,
                    shopIndex: item.shopIndex,
                    copies: Number(item.copies),
                }))

            this.$store.dispatch('shipments/sendings/setGenerateEANLabels', {
                EANLabels: EANLabels,
                fileName: this.fileName,
                shop: availableClients[0],
                printerId: this.printerId
            })
        },
        printCustomLabels(item) {
            this.$store.dispatch('shipments/sendings/setGenerateCustomLabels', { 
                customLabels: item, 
                fileName: this.fileName,
                shop: availableClients[1],
                printerId: this.printerId
            })
        },
        importDataLabels(data) {
            this.items = [...data]
            this.setHeaders()
        },
        xlsDataLoaded({data, fileName}) {
            this.xlsData = data.filter(i => i.length > 0)
            this.fileName = fileName
            
            this.generateTableItems()
        },
        generateTableItems() {
            if (this.xlsData) {
                const keys = this['headers' + this.currentClient]

                this.items = this.xlsData.map((row, i) => {
                    if (i === 0 && this.currentClient === availableClients[0]) {
                        return false
                    }

                    if (
                        row.every(
                            item => item === null ||
                            item === undefined ||
                            (typeof item == 'string' && item.trim() === '')
                        )
                    ) {
                        return false
                    }
                    
                    return Object.fromEntries([
                        ...row.map((col, index) => {
                            if (index == keys.length) return null
                            
                            if (keys[index].value === 'copies') {
                                return [keys[index].value, 0]
                            }

                            return [keys[index].value, col]
                        }).filter(j => j),
                        ['id', i - 1] 
                    ])
                }).filter(i => i)
                this.setHeaders()
                this.updated = false
            }
        },
        setHeaders() {
            this.headers = [...this['headers' + this.currentClient], ...this.headersInitial]
        },
        actualPrintIconColor(item) {
            if (this.currentClient === this.availableClients[1]) {
                return 'blue'
            }

            return item.copies > 0 ? 'blue' : 'grey'
        },
        clearIfNil(item) {
            if (item.copies == 0) {
                item.copies = ''
            }
        },
        close() {
            router.push({ name: 'ShippingLabelsGeneratorAll' })
                .catch(error => {
                    errorHandler(error)
                })
        }
    }
}
</script>